import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const MASK_STYLE = {
  maskImage: "linear-gradient(to left, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0) 95%)",
  WebkitMaskImage:
    "linear-gradient(to left, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0) 95%)",
};

export const HeroBackgroundCarousel = ({ slides, activeIdx }) => (
  <div
    data-testid="hero-carousel"
    className="absolute inset-y-0 right-0 w-full lg:w-1/2 opacity-[0.22] lg:opacity-100 pointer-events-none"
  >
    <AnimatePresence mode="sync">
      <motion.img
        key={slides[activeIdx].key}
        src={slides[activeIdx].url}
        alt=""
        data-testid={`hero-slide-${slides[activeIdx].key}`}
        initial={{ opacity: 0, scale: 1.06 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0 }}
        transition={{
          opacity: { duration: 1.4, ease: "easeInOut" },
          scale: { duration: 6, ease: "easeOut" },
        }}
        className="absolute inset-0 w-full h-full object-cover"
        style={MASK_STYLE}
      />
    </AnimatePresence>
  </div>
);

export const HeroSlideDots = ({ slides, activeIdx, onSelect }) => (
  <div className="hidden lg:flex absolute bottom-10 right-10 z-20 items-center gap-2">
    {slides.map((s, i) => (
      <button
        key={s.key}
        data-testid={`hero-slide-dot-${s.key}`}
        onClick={() => onSelect(i)}
        aria-label={`Mostrar ${s.label}`}
        className={`transition-all ${
          i === activeIdx
            ? "w-8 h-[2px] bg-razmek-gold"
            : "w-5 h-[2px] bg-razmek-dark/25 hover:bg-razmek-dark/60"
        }`}
      />
    ))}
  </div>
);
